import React from "react";
import { FaCheck } from "react-icons/fa";

// Progress Steps
export const ProgressSteps = ({ steps, currentStep, className = "" }) => (
  <div className={`flex items-center justify-center space-x-8 ${className}`}>
    {steps.map((step, index) => (
      <div
        key={index}
        className={`flex items-center space-x-2 ${
          currentStep >= index + 1 ? "text-brand-charcoal" : "text-brand-mist"
        }`}
      >
        <div
          className={`
            w-8 h-8 rounded-lg flex items-center justify-center text-sm font-bold
            ${
              currentStep >= index + 1
                ? "bg-brand-charcoal text-brand-cream"
                : "bg-brand-cream text-brand-muted"
            }
          `}
        >
          {currentStep > index + 1 ? (
            <FaCheck className="w-4 h-4" />
          ) : (
            index + 1
          )}
        </div>
        <span className="font-medium">{step}</span>
      </div>
    ))}
  </div>
);

export default ProgressSteps;
